import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import {getTheme} from "./_common/GetTheme";
// import translationEN from './locales/en/strings.json';
// import translationHE from './locales/he/strings.json';

import defaultEn from './_themes/default/text/en-us.json'
import defaultHe from './_themes/default/text/he-IL.json'
import defaultEs from './_themes/default/text/es.json'
import barrierEn from './_themes/barrier/text/en-us.json'
import barrierHe from './_themes/barrier/text/he-IL.json'

const resources = (function () {
    switch (getTheme()) {
      case 'barrier':
        return (
          {
            en: {
              translation: barrierEn
            },
            // he: {
            //     translation: barrierHe 
            //   }
          }
        )
    
      default:
        return (
          {
            en: {
              translation: defaultEn
            },
            // he: {
            //   translation: defaultHe 
            // },
            es: {
              translation: defaultEs 
            }
      }
        )
    }
}());
    
i18n
  .use(initReactI18next) 
  // detect user language 
  .use(LanguageDetector)
  .init({
    resources,
   
    
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });
  let phoneLang = i18n.language.substring(0, 2);
  if (!resources[phoneLang]){
    i18n.changeLanguage('en');
  }
 
//  var a = i18n.language;
//  alert(a);
//  i18n.changeLanguage('he-IL');
//i18n.changeLanguage('es');

  export default i18n;
  